import { Link } from "react-router-dom";
import { useSite } from "../context/SiteContext";

export default function NotFound() {
  const { settings } = useSite();
  const logo = settings?.logo_path || "/lemur-logo.png";
  return (
    <section className="page-hero" style={{ minHeight: "70vh", display: "grid", placeItems: "center" }} data-testid="not-found-page">
      <div className="watermark" style={{ right: "-100px", bottom: "-80px", width: "420px", height: "420px", opacity: 0.06 }} aria-hidden="true">
        <img src={logo} alt="" />
      </div>
      <div className="wrap" style={{ textAlign: "center", position: "relative", zIndex: 2 }}>
        <span className="eyebrow light" style={{ justifyContent: "center" }}>Error 404</span>
        <h1 style={{ fontSize: "clamp(3rem,8vw,5.5rem)", margin: "18px 0" }}>
          <span style={{ background: "linear-gradient(90deg,var(--amber),var(--crimson))", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>
            Page not found
          </span>
        </h1>
        <p style={{ color: "rgba(255,255,255,.78)", fontSize: "1.1rem", maxWidth: "48ch", margin: "0 auto 30px" }}>
          The page you are looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
          <Link to="/" className="btn btn-light" data-testid="notfound-home">Back to home</Link>
          <Link to="/contact" className="btn btn-outline-light" data-testid="notfound-contact">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
